<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title v-if="idTarea && !readonly" sliding>{{$t('crontask.editar')}}</f7-nav-title>
      <f7-nav-title v-else-if="idTarea" sliding>{{$t('crontask.tareaprogramada')}}</f7-nav-title>
      <f7-nav-title v-else sliding>{{$t('crontask.nuevo')}}</f7-nav-title>
      <f7-nav-right>
        <f7-button
          v-if="!readonly"
          fill
          icon-f7="floppy_disk"
          text="Guardar"
          class="display-flex"
          @click="$refs.rform.saveItem()"
        ></f7-button>
        <template slot="right" v-else>
          <f7-button color="blue" @click="readonly=false">{{$t('common.editar')}}</f7-button>
          <f7-button color="red" @click="deleteItem">{{$t('common.eliminar')}}</f7-button>
        </template>
      </f7-nav-right>
    </f7-navbar>

    <r-form
      ref="rform"
      v-slot="{rform}"
      :itemId="idTarea"
      @save="onSave"
      @loadItem="onLoadItem"
      :readonly="readonly"
      :dbAdapter="CronTask"
      :default-data="defaultData"
      :before-save="comprobarPares"
    >
      <f7-card class="padding-vertical-half padding-right" style="z-index: 3000">
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="100" medium="100">
                <r-input
                  outline
                  class="col-100"
                  floating-label
                  :label="$t('crontask.descripcion')"
                  :form="rform"
                  type="text"
                  name="descripcion"
                ></r-input>
            </f7-col>
            <f7-col width="50" medium="50" small="100">
                <r-input
                  outline
                  class="col-100 medium-50"
                  floating-label
                  :label="$t('crontask.beanName')"
                  :form="rform"
                  type="text"
                  name="beanName"
                ></r-input>
                <r-input
                  outline
                  class="col-30 medium-30"
                  floating-label
                  :label="$t('crontask.orden')"
                  :form="rform"
                  type="number"
                  name="orden"
                ></r-input>
                <r-input
                  outline
                  class="col-30 medium-30"
                  floating-label
                  :label="$t('crontask.ejecutarSola')"
                  :form="rform"
                  type="check"
                  name="ejecutarSola"
                ></r-input>
                <r-input
                  outline
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('crontask.estado')"
                  :form="rform"
                  type="select"
                  name="estado"
                >
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="EN_EJECUCION">EN_EJECUCION</option>
                  <option value="TERMINADA">TERMINADA</option>
                  <option value="PAUSADA">PAUSADA</option>
                  <option value="CANCELADA">CANCELADA</option>
                </r-input>
            </f7-col>
            <f7-col width="50" medium="50" small="100">
                <f7-block class="col-100 medium-50 cron-help-block no-margin-top no-margin-bottom" style="border-radius: 5px;border: 1px solid gray;background-color: antiquewhite;">
                  <r-input
                    floating-label
                    style="background-color: white;border-top-left-radius: 4px;border-top-right-radius: 4px;"
                    :label="$t('crontask.cronExpression')"
                    :form="rform"
                    type="text"
                    name="cronExpression"
                  ></r-input>
                  <div class="cron-help-title">{{$t('crontask.ayudaCron')}}</div>
                  <div class="cron-help-title display-flex flex-wrap">
                    <f7-button
                      v-for="preset in cronPresets"
                      :key="preset.label"
                      small
                      tonal
                      class="cron-preset-btn"
                      @click="applyCronPreset(preset.value)"
                    >
                      {{preset.label}}
                    </f7-button>
                  </div>
                </f7-block>
            </f7-col>
            <f7-col width="20" medium="20" small="50">
                <r-input
                  outline
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('crontask.limiteIntentos')"
                  :form="rform"
                  type="number"
                  name="limiteIntentos"
                ></r-input>
            </f7-col>
            <f7-col width="20" medium="20" small="50">
                <r-input
                  outline
                  class="col-100 medium-25"
                  floating-label
                  :label="$t('crontask.resultadoUltimaEjecucion')"
                  :form="rform"
                  type="select"
                  name="resultadoUltimaEjecucion"
                >
                  <option value=""></option>
                  <option value="OK">OK</option>
                  <option value="KO">KO</option>
                </r-input>
            </f7-col>
            <f7-col width="50" medium="70" small="100">
                <r-input
                  outline
                  class="col-100"
                  floating-label
                  :label="$t('crontask.observacionesEjecucion')"
                  :form="rform"
                  type="textarea"
                  name="observacionesEjecucion"
                ></r-input>
            </f7-col>
            <f7-col width="50" medium="30" small="100">
                <r-input
                  v-if="idTarea"
                  outline
                  class="col-50 medium-50"
                  floating-label
                  :label="$t('crontask.fechaUltimaEjecucion')"
                  :form="rform"
                  type="datetime-local"
                  name="fechaUltimaEjecucion"
                  :readonly="true"
                ></r-input>
                <r-input
                  v-if="idTarea"
                  outline
                  class="col-50 medium-50"
                  floating-label
                  :label="$t('crontask.fechaCalculadaProximaEjecucion')"
                  :form="rform"
                  type="datetime-local"
                  name="fechaCalculadaProximaEjecucion"
                  :readonly="true"
                ></r-input>
            </f7-col>
            <!-- Estos cuatro campos no se escriben a mano: los rellena la ejecución. Así que dicen
                 aquí, JUNTO a ellos y no en un rótulo al principio de la pantalla, quién los
                 rellena y cuándo (regla de dirección del 05/10/2026). Dirección probó la tarea el
                 16 y el 17/10 y los vio vacíos sin saber si eso era un fallo o el diseño. -->
            <f7-col v-if="idTarea" width="100" medium="100">
              <p class="crontask-nota">{{$t('crontask.ejecucionAyuda')}}</p>
              <p class="crontask-nota">{{$t('crontask.proximaAyuda')}}</p>
            </f7-col>
          </f7-row>
        </f7-card-content>
      </f7-card>
      <!-- Los parámetros de la tarea (`datos` del documento `cronTask`). No se podían ni ver ni
           escribir desde ninguna pantalla, y hay tareas que los necesitan para poder probarse:
           el cierre nocturno de vacaciones (#62) lee de aquí `fechaSimulada`. Es un mapa libre,
           así que se edita como pares clave/valor y no con un campo por tarea. -->
      <f7-card class="padding-vertical-half padding-right">
        <f7-card-content>
          <div class="label-group">{{$t('crontask.datos')}}</div>
          <p class="crontask-nota">{{$t('crontask.datosAyuda')}}</p>
          <div
            v-for="(par, i) in pares"
            :key="'dato'+i"
            class="crontask-dato"
          >
            <input
              type="text"
              class="crontask-dato-clave"
              :class="{'crontask-dato-repetida': esClaveRepetida(par)}"
              :placeholder="$t('crontask.datosClave')"
              :readonly="readonly"
              v-model="par.clave"
              @input="sincronizarDatos(rform)"
            />
            <input
              type="text"
              class="crontask-dato-valor"
              :placeholder="$t('crontask.datosValor')"
              :readonly="readonly"
              v-model="par.valor"
              @input="editarValor(rform, par)"
            />
            <f7-link
              v-if="!readonly"
              icon-f7="trash"
              color="red"
              v-tooltip="$t('common.eliminar')"
              @click="quitarPar(rform, i)"
            ></f7-link>
            <!-- El aviso va en la propia fila, no en un rótulo al principio de la tarjeta: quien
                 escribe el nombre repetido tiene que leer ahí mismo qué pasa y qué hacer
                 (dirección, 05/10/2026). Ocupa su renglón dentro de la fila. -->
            <span
              v-if="esClaveRepetida(par)"
              class="crontask-nota crontask-aviso-fila"
            >{{$t('crontask.datosClaveRepetida')}}</span>
          </div>
          <p v-if="!pares.length" class="crontask-nota">{{$t('crontask.datosVacio')}}</p>
          <div v-if="!readonly" class="crontask-dato-add">
            <f7-button small fill @click="anadirPar">{{$t('crontask.datosAnadir')}}</f7-button>
          </div>
        </f7-card-content>
      </f7-card>

      <!-- Lanzarla a mano. Ya se podía desde el icono de la lista, pero no desde aquí, que es
           donde se miran y se guardan los parámetros con los que se quiere lanzar. -->
      <f7-card v-if="idTarea" class="padding-vertical-half padding-right">
        <f7-card-content>
          <div class="label-group">{{$t('crontask.lanzar')}}</div>
          <div class="crontask-lanzar">
            <f7-button
              fill
              color="green"
              :disabled="!puedeLanzar"
              @click="lanzar"
            >{{$t('crontask.lanzarAhora')}}</f7-button>
            <!-- El aviso va junto al botón a propósito: un control apagado tiene que decir ahí
                 mismo por qué, quién lo desbloquea y dónde (dirección, 05/10/2026). -->
            <span class="crontask-nota crontask-nota-inline">{{avisoLanzar}}</span>
          </div>
        </f7-card-content>
      </f7-card>

      <pre style="display:none;">{{rform.formData}}</pre>
    </r-form>
  </f7-page>
</template>

<script>
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import CronTask from "./../../js/db/CronTask.js";
import preloaderDeLaSesion from "./../../js/utils/preloaderDeLaSesion.js";
import cerrojoDeLaSesion from "./../../js/utils/cerrojoDeLaSesion.js";

export default {
  components: {
    rForm,
    rInput
  },
  data: function() {
    return {
      CronTask,
      readonly: !this.editable,
      // Los `datos` del documento, como lista de pares: un mapa no se puede recorrer con v-model
      // sin perder el orden al renombrar una clave. La lista es la que se edita y de ella se
      // reconstruye el mapa en cada pulsación (`sincronizarDatos`). Cada par lleva además el valor
      // que llegó (`original`, en la caja de `comoLlego` para que la reactividad no lo toque) y si
      // alguien ha tocado su campo (`tocada`): ver `valorQueSeGuarda`.
      pares: [],
      lanzando: false,
      // El id que devuelve el servidor al crear la tarea. La prop `id` llega de la ruta y en
      // `/tareasprogramadas/new/` se queda indefinida para siempre, así que sin esto la tarea
      // recién creada no se podía lanzar ni volver a guardar: ver `idTarea`.
      idCreado: null,
      defaultData: {
        cronExpression: "0 0 4 * * MON-FRI",
        orden: 999,
        ejecutarSola: false,
        estado: "PENDIENTE",
        limiteIntentos: 1,
        datos: {}
      },
      cronPresets: [
        { label: "Cada 5 min", value: "0 */5 * * * *" },
        { label: "Cada hora", value: "0 0 * * * *" },
        { label: "Diario 04:00", value: "0 0 4 * * *" },
        { label: "L-V 04:00", value: "0 0 4 * * MON-FRI" },
        { label: "Semanal lun 04:00", value: "0 0 4 * * MON" },
        { label: "Mensual día 1", value: "0 0 4 1 * *" }
      ]
    };
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    /**
     * La tarea que hay delante: la de la ruta o la que se acaba de crear.
     *
     * La prop `id` solo la trae la ruta de una tarea que ya existía, de modo que al guardar desde
     * «nuevo» seguía indefinida aunque la tarea ya estuviera creada: la tarjeta de lanzar no se
     * dibujaba, el botón no se desbloqueaba y había que volver a la lista y abrirla otra vez
     * (revisión del PR #1790). Y había una segunda mitad: `rForm` decide por este mismo id si
     * guardar es un POST o un PUT, así que un segundo guardado sin salir de la pantalla creaba una
     * tarea duplicada.
     */
    idTarea: function() {
      return this.id || this.idCreado;
    },
    // Se lanza lo que está GUARDADO: la ejecución lee la tarea de la base de datos, no lo que haya
    // en la pantalla. Así que en modo edición el botón está apagado, para no prometer que se va a
    // ejecutar con lo que se acaba de teclear.
    puedeLanzar: function() {
      return !!this.idTarea && this.readonly && !this.lanzando;
    },
    avisoLanzar: function() {
      if (this.lanzando) return this.$t("crontask.lanzarEnCurso");
      if (!this.readonly) return this.$t("crontask.lanzarGuardaPrimero");
      return this.$t("crontask.lanzarAviso");
    },
    /**
     * Los nombres de parámetro que aparecen más de una vez, ya recortados igual que los recorta
     * `sincronizarDatos`: «hora» y «hora » son el mismo parámetro del mapa.
     *
     * El mapa es un `Map<String, Object>`: dos filas con el mismo nombre se ven las dos en la
     * pantalla pero al reconstruirlo la segunda tapa a la primera sin decir nada, y al guardar
     * desaparece un parámetro —o, peor, la tarea se ejecuta con un valor distinto del que se está
     * viendo (revisión del PR #1790)—. Así que se señala en la fila y no se deja guardar.
     */
    clavesRepetidas: function() {
      const vistas = Object.create(null);
      const repetidas = [];
      this.pares.forEach(function(par) {
        const clave = (par.clave || "").trim();
        if (!clave) return;
        if (vistas[clave]) {
          if (vistas[clave] === 1) repetidas.push(clave);
          vistas[clave]++;
        } else {
          vistas[clave] = 1;
        }
      });
      return repetidas;
    }
  },
  methods: {
    onLoadItem: function(res) {
      this.tomarEstadoDe(res);
    },
    /**
     * <b>La pantalla toma su estado del documento que contesta el servidor.</b> Única puerta: la
     * carga y el guardado pasan las dos por aquí.
     *
     * Hay estado de pantalla que no vive en `formData` y que se deduce del documento: la lista de
     * pares con el valor que llegó (`original`) y la marca de editado (`tocada`), y el id de la
     * tarea recién creada. `rForm` solo sabe de `formData`, de modo que al guardar se sustituía ese
     * y lo demás se quedaba como estaba antes de guardar; la revisión del PR #1790 lo ha traído dos
     * veces, una por cada pieza: primero el id —la tarea creada no se podía lanzar— y después los
     * pares, que en un segundo ciclo de edición mandaban el valor con el tipo de antes de guardar
     * (un número que se pasó a texto y se vuelve a editar salía otra vez numérico). Mientras cada
     * pieza se refrescara por su cuenta, olvidar una era una ronda de revisión.
     */
    tomarEstadoDe: function(res) {
      // El mapa es `Map<String, Object>` y el campo de la pantalla es de texto, así que para
      // ENSEÑARLO se pasa a texto; el valor que llegó se guarda al lado tal cual, porque es el que
      // vuelve al documento mientras nadie toque esa fila: ver `valorQueSeGuarda`.
      //
      // Se recorre con `Object.keys`, que solo da claves propias, y eso basta porque el documento
      // llega por `CronTask.get`/`CronTask.save`, que reconstruyen el mapa antes de que nadie lo
      // toque: sin eso, un parámetro llamado `__ob__` ya venía pisado por la reactividad de Vue y
      // esta vuelta no lo enseñaba.
      const datos = res?.datos || {};
      const self = this;
      this.pares = Object.keys(datos).map(function(clave) {
        const valor = datos[clave];
        return {
          clave: clave,
          valor: self.comoTexto(valor),
          original: self.comoLlego(valor),
          tocada: false
        };
      });
      if (res?.id) {
        this.idCreado = res.id;
      }
    },
    /**
     * El documento que contesta el servidor a una ESCRITURA —guardar, o lanzar la tarea—: manda él
     * y la pantalla entera se rehace de ahí.
     *
     * <b>Única puerta de las dos escrituras</b>, y por eso existe: guardar ya lo hacía (el
     * `formData` por un lado y el estado de la pantalla por otro) y lanzar necesitaba lo mismo
     * —desde que la ejecución deja constancia, su respuesta trae el resultado y las fechas—. Con
     * cada una refrescando la ficha a su manera, olvidar una pieza en una de las dos es una ronda
     * de revisión; eso ya pasó dos veces en el PR #1790.
     */
    tomarEstadoDeLoEscrito: function(res) {
      if (!res) return;
      const rform = this.$refs && this.$refs.rform;
      if (rform) rform.formData = res;
      this.tomarEstadoDe(res);
    },
    /**
     * El valor que llegó, guardado en la fila <b>dentro de una caja congelada</b> y no a pelo.
     *
     * Es la tercera vez que la reactividad de Vue 2 se queda con el nombre `__ob__` de un
     * parámetro, y la única puerta que quedaba abierta (revisión del PR #1790). El mapa de
     * `formData.datos` ya está cerrado —`CronTask.mapaDeParametros` lo congela, y Vue no observa un
     * objeto congelado ni, por tanto, baja a sus valores—, pero `pares` <b>sí</b> es reactivo: al
     * meter ahí el valor tal cual, su `Observer` lo recorre, le instala un `__ob__` propio no
     * enumerable y pisa el que hubiera dentro. Y como el valor es la MISMA referencia que hay en
     * `formData.datos`, el destrozo llega al documento: basta abrir la ficha y guardar para que
     * `JSON.stringify` se deje fuera esa propiedad, sin haber tocado el parámetro.
     *
     * La caja lo resuelve igual que allí y por lo mismo: Vue no observa la caja porque está
     * congelada, y al no observarla no entra en lo que lleva dentro, que queda intacto. Se congela
     * la caja y no el valor a propósito: el valor es del documento del servidor y aquí solo se
     * lee; congelarlo sería cambiarle a otro lo que tiene entre manos.
     */
    comoLlego: function(valor) {
      return Object.freeze({ valor: valor });
    },
    // Un valor del documento, tal como se enseña en el campo. Los compuestos van en JSON y no como
    // `String(valor)`, que los dejaba en «[object Object]»: así se ven y se pueden editar.
    comoTexto: function(valor) {
      if (valor === null || valor === undefined) return "";
      if (typeof valor === "object") return JSON.stringify(valor);
      return String(valor);
    },
    /**
     * La lista de pares, de vuelta al mapa. Se reescribe entero en cada cambio para que quitar un
     * par lo quite de verdad del documento, y no solo de la pantalla.
     *
     * El mapa lo construye `CronTask.mapaDeParametros`, que es la única puerta por la que se monta:
     * ahí está escrito —y por qué— que ninguna fila se pierde por cómo se llame el parámetro. La
     * pantalla solo decide qué filas entran y con qué valor.
     */
    sincronizarDatos: function(rform) {
      const entradas = [];
      const self = this;
      this.pares.forEach(function(par) {
        const clave = (par.clave || "").trim();
        if (clave) entradas.push([clave, self.valorQueSeGuarda(par)]);
      });
      this.$set(rform.formData, "datos", CronTask.mapaDeParametros(entradas));
    },
    /**
     * Lo único que escribe el campo del valor, y por eso lo único que marca la fila como tocada.
     *
     * Es un sitio tonto a propósito: mientras no haya más de uno, no hay forma de cambiar un valor
     * sin que quede dicho que se ha cambiado, que es lo que distingue «esto lo ha escrito alguien»
     * de «esto es lo que llegó». Si algún día hiciera falta otra forma de editar el valor —pegar un
     * JSON, un botón de limpiar—, pasa por aquí.
     */
    editarValor: function(rform, par) {
      par.tocada = true;
      this.sincronizarDatos(rform);
    },
    /**
     * Qué valor se manda al servidor por esta fila.
     *
     * Una fila que nadie ha tocado devuelve el valor que llegó, **sin pasar por el texto**: el mapa
     * es `Map<String, Object>` y admite números, booleanos, listas, objetos y nulos, y
     * reconstruirlos del texto de la pantalla convertía en cadenas —o en «[object Object]»—
     * parámetros que ni se estaban editando, porque `sincronizarDatos` rehace el mapa entero en
     * cada pulsación (revisión del PR #1790).
     *
     * Y la fila que sí se ha cambiado conserva su tipo cuando se sabe cuál era: si el valor que
     * llegó no era texto, lo tecleado se interpreta como JSON, que es lo que permite volver a
     * escribir un 3 o un true sin convertirlos en cadenas. Si era texto, si no llegó nada (nulo) o
     * si la fila es nueva, se manda tal como se escribió: ahí no hay tipo de partida y
     * adivinárselo es cambiarlo igual.
     *
     * **Lo decide la marca de la fila y no comparar el texto**, que es lo que había y lo que la
     * segunda ronda de revisión tumbó: el texto de la pantalla no distingue un nulo de una cadena
     * vacía —`comoTexto(null)` es `""`—, así que vaciar un parámetro que llegó nulo se tomaba por
     * «no se ha tocado» y volvía a mandar el nulo. Con la marca, el valor en blanco que promete la
     * ayuda de la pantalla se puede guardar siempre, venga de donde venga.
     *
     * Y «lo que llegó» se lee de la caja de `comoLlego`, no de la fila: que la caja esté o no es
     * además lo que distingue una fila cargada de una fila nueva, que no tiene valor de partida.
     */
    valorQueSeGuarda: function(par) {
      const llego = par.original;
      if (!llego) return par.valor;
      if (!par.tocada) return llego.valor;
      if (llego.valor === null || llego.valor === undefined) return par.valor;
      return typeof llego.valor === "string" ? par.valor : this.comoValor(par.valor);
    },
    // Lo tecleado, con el tipo que se le reconozca. Lo que no sea JSON válido —una fecha, un
    // código, un texto cualquiera— se queda tal cual: es el caso normal.
    comoValor: function(texto) {
      if (texto === "") return "";
      try {
        const valor = JSON.parse(texto);
        return typeof valor === "string" ? texto : valor;
      } catch (e) {
        return texto;
      }
    },
    /** ¿Es esta fila una de las que repiten nombre? Lo que pone el aviso junto a ella. */
    esClaveRepetida: function(par) {
      const clave = (par.clave || "").trim();
      return !!clave && this.clavesRepetidas.indexOf(clave) >= 0;
    },
    /**
     * El guardado no sale si hay nombres repetidos: lo que se vería guardado no sería lo que hay
     * en la pantalla. `rForm` convierte este `reject` en el aviso y deja la pantalla como está.
     */
    comprobarPares: function(data, resolve, reject) {
      if (this.clavesRepetidas.length) {
        reject({
          message: this.$t("crontask.datosNoSeGuarda") + this.clavesRepetidas.join(", ")
        });
        return;
      }
      resolve(data);
    },
    anadirPar: function() {
      // Sin `original`: una fila nueva no tiene valor de partida que conservar, y lo que se
      // escriba en ella es siempre de quien la ha añadido.
      this.pares.push({ clave: "", valor: "", tocada: true });
    },
    quitarPar: function(rform, i) {
      this.pares.splice(i, 1);
      this.sincronizarDatos(rform);
    },
    lanzar: function() {
      const app = this.$f7;
      if (!this.puedeLanzar) return;
      app.dialog.confirm(
        this.$t("crontask.confirmarEjecucion"),
        this.$t("crontask.lanzarAhora"),
        () => {
          // #663 · La espera y el cerrojo de la sesión: si la sesión cambia en vuelo, la frontera
          // calla el `then` que los soltaba.
          cerrojoDeLaSesion(this, 'lanzando');
          const espera = preloaderDeLaSesion(this);
          espera.mostrar();
          CronTask.execute({ itemId: this.idTarea })
            .then(res => {
              // La respuesta es la tarea COMO HA QUEDADO GUARDADA, así que la ficha se rehace de
              // ella: el resultado, la fecha de esta ejecución, las observaciones y la próxima
              // ejecución calculada se ven en el momento, sin recargar, y siguen ahí al recargar.
              this.tomarEstadoDeLoEscrito(res);
              const resultado = CronTask.resultadoEjecucion(res);
              app.toast
                .create({
                  icon: resultado.ok
                    ? '<i class="f7-icons">checkmark</i>'
                    : '<i class="f7-icons">xmark_octagon</i>',
                  text: this.$t(resultado.clave),
                  position: "center",
                  destroyOnClose: true,
                  closeTimeout: resultado.ok ? 2000 : 5000
                })
                .open();
            })
            .catch(error => {
              app.dialog.alert(
                error?.message || error?.error || this.$t("crontask.ejecucionKo")
              );
            })
            .then(() => {
              this.lanzando = false;
              espera.cerrar();
            });
        }
      );
    },
    applyCronPreset: function(value) {
      if (this.$refs.rform && this.$refs.rform.formData) {
        this.$set(this.$refs.rform.formData, "cronExpression", value);
      }
    },
    deleteItem: function() {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        self.$t("common.eliminar"),
        function() {
          CronTask.delete({ itemId: self.idTarea }).then(function(res) {
            if (res) {
              app.toast
                .create({
                  icon: '<i class="f7-icons">checkmark</i>',
                  text: self.$t("rlist.registro_eliminado"),
                  position: "center",
                  destroyOnClose: true,
                  closeTimeout: 2000
                })
                .open();
              self.$f7router.back();
            }
          }).catch(function(error) {
            app.dialog.alert(error.message || error.error || error);
          });
        }
      );
    },
    onSave: function(res) {
      var self = this;
      var app = self.$f7;
      // El documento que acaba de contestar el servidor es el que manda, igual que si se volviera a
      // entrar: por eso pasa por la misma puerta que la ejecución. Con eso la tarea recién creada ya
      // se puede lanzar y el siguiente guardado es un PUT sobre ella.
      self.tomarEstadoDeLoEscrito(res);
      self.readonly = true;
      app.toast
        .create({
          text: self.$t("crontask.guardado_ok"),
          position: "center",
          closeTimeout: 2000,
          icon: '<i class="f7-icons">checkmark_alt</i>'
        })
        .open();
    }
  }
};
</script>

<style scoped>
.label-group {
  margin-top: 12px;
  margin-left: 20px;
  font-weight: bold;
}

.crontask-nota {
  margin: 4px 20px 8px;
  font-size: 12px;
  color: #777;
}

/* Sin `gap`: el browserslist del repo baja a Chrome 49 y el `gap` de flex es de Chrome 84. */
.crontask-dato {
  display: flex;
  align-items: center;
  /* El `wrap` está siempre, no solo en pantalla estrecha: mientras todo cabe en el renglón no
     cambia nada, y es lo que deja caer el aviso de nombre repetido a su propia línea sin tocar la
     colocación de los dos campos. */
  flex-wrap: wrap;
  margin: 0 20px 6px;
}

.crontask-dato input {
  padding: 6px 10px;
  border: 1px solid #d4dde8;
  border-radius: 8px;
  font-size: 13px;
  margin-right: 8px;
}

.crontask-dato-clave {
  flex: 0 0 220px;
  min-width: 0;
}

.crontask-dato-valor {
  flex: 1;
  min-width: 0;
}

/* La aplicación se usa también en Cordova, sobre pantallas de 320–360 px, y ahí los 220 px de la
   clave más el valor, el icono de borrar y los márgenes de la tarjeta no caben en un renglón: como
   el valor puede encogerse hasta cero, se quedaba en nada y la fila no se podía editar. Por debajo
   de 480 px la clave ocupa su propio renglón y el valor recupera el ancho entero. */
@media (max-width: 480px) {
  .crontask-dato {
    flex-wrap: wrap;
  }

  /* Con `.crontask-dato-clave` a secas el `margin-right` no se quitaría: lo pone
     `.crontask-dato input`, que tiene un elemento más y gana. */
  .crontask-dato input.crontask-dato-clave {
    flex: 1 1 100%;
    margin-right: 0;
    margin-bottom: 4px;
  }
}

/* El nombre repetido, señalado en el campo: el aviso de al lado dice qué hacer. */
.crontask-dato input.crontask-dato-repetida {
  border-color: #d32f2f;
}

.crontask-aviso-fila {
  flex: 1 1 100%;
  margin: 0 0 4px;
  color: #d32f2f;
}

.crontask-dato-add {
  margin: 0 20px 8px;
}

.crontask-lanzar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 20px 8px;
}

.crontask-lanzar .button {
  margin-right: 10px;
}

.crontask-nota-inline {
  margin: 4px 0;
  flex: 1;
  min-width: 200px;
}

.cron-help-block {
  padding: 0 0 8px 0;
}

.cron-help-title {
  font-size: 12px;
  color: var(--f7-text-color-secondary);
  margin-bottom: 6px;
  margin-left: 16px
}

.cron-preset-btn {
  margin-right: 6px;
  margin-bottom: 6px;
}
</style>
